
import React, { useEffect, useState } from 'react';
import { Popup } from '../types';
import { X } from 'lucide-react';

interface PopupDisplayProps {
  popup: Popup;
}

const PopupDisplay: React.FC<PopupDisplayProps> = ({ popup }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasClosed, setHasClosed] = useState(false);

  useEffect(() => {
    // 1. Verifica se existe configuração de cooldown (horas para reaparecer)
    if ((popup.reappearHours || 0) > 0) {
        const closedTimestamp = localStorage.getItem(`popup_closed_${popup.id}`);
        if (closedTimestamp) {
            const lastClosed = parseInt(closedTimestamp, 10);
            const now = Date.now();
            const hoursPassed = (now - lastClosed) / (1000 * 60 * 60);
            
            // Se ainda não passou o tempo configurado, não exibe
            if (hoursPassed < popup.reappearHours!) {
                return;
            }
        }
    }

    const timer = setTimeout(() => {
        setIsVisible(true);
    }, (popup.delay || 3) * 1000); 

    return () => clearTimeout(timer);
  }, [popup]);

  const handleClose = () => {
      setIsVisible(false);
      setHasClosed(true);
      localStorage.setItem(`popup_closed_${popup.id}`, Date.now().toString());
  };

  if (!isVisible || hasClosed) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-fade-in w-screen h-screen overflow-hidden">
        <div className="relative bg-white rounded-[40px] shadow-[0_35px_100px_rgba(0,0,0,0.5)] w-full max-w-lg overflow-hidden animate-fade-in-down border border-white/20">
            {/* Botão de Fechar mais destacado */}
            <button 
                onClick={handleClose}
                className="absolute top-5 right-5 z-30 p-2.5 bg-black/60 hover:bg-black text-white rounded-full transition-all hover:scale-110 shadow-lg"
                title="Fechar Oferta"
            >
                <X size={24} />
            </button>

            <a href={popup.linkUrl || '#'} target="_blank" rel="noopener noreferrer" className="block group">
                <div className="relative aspect-square md:aspect-[4/3] w-full bg-slate-100">
                    <img 
                        src={popup.imageUrl} 
                        alt={popup.name} 
                        className="w-full h-full object-cover transition-transform duration-[2000ms] group-hover:scale-110" 
                    />
                    
                    {/* Overlay elegante sempre presente */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent flex flex-col justify-end p-10">
                        <div className="transform translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                            <span className="inline-block bg-primary text-white text-[10px] font-black px-4 py-1.5 rounded-full uppercase tracking-[0.2em] mb-4 shadow-xl border border-white/20">
                                Oportunidade Única
                            </span>
                            <h3 className="text-3xl md:text-4xl font-black text-white leading-none tracking-tighter uppercase drop-shadow-2xl">
                                {popup.name}
                            </h3>
                            <div className="mt-6 flex items-center gap-3 text-white/70 font-bold text-xs uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity">
                                Aproveitar Agora <X size={16} className="rotate-45" />
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>
  );
};

export default PopupDisplay;
